import styled from 'styled-components';
import { PropertyItem } from '../PropertyGroup';
export var Container = styled.div.withConfig({
  displayName: "SearchablePropertystyles__Container",
  componentId: "keen-query-creator__sc-vnyu6m-0"
})(["&&&{position:relative;display:inline-flex;flex-direction:column;}"]);
export var DropdownContent = styled.div.withConfig({
  displayName: "SearchablePropertystyles__DropdownContent",
  componentId: "keen-query-creator__sc-vnyu6m-1"
})(["&&&{width:285px;}"]);
export var StyledPropertyItem = styled(PropertyItem).withConfig({
  displayName: "SearchablePropertystyles__StyledPropertyItem",
  componentId: "keen-query-creator__sc-vnyu6m-2"
})(["&&&{background:none;}&&&.drag-handle{cursor:grab;display:flex;align-items:center;padding:0 10px;}"]);